module.exports = __webpack_public_path__ + "static/media/04.4b0a65a0.png";